import { useQuery } from '@tanstack/react-query';

import { BindingsApi } from '@/api/domains/bindings.api';
import type { Binding } from '@/api/domains/bindings.types';
import { ReconciliationQueryKeys } from '@/api/domains/reconciliation.query-keys';

import { useReconciliationOrderGuid } from '../reconciliation-file.store';

export type ReconciliationUnboundBinding = Pick<Binding, 'id' | 'name' | 'maker_name' | 'maker_country_name'>;

const selectUnboundBindings = (data: { items: Binding[] }): ReconciliationUnboundBinding[] =>
  data.items.map(item => ({
    id: item.id,
    name: item.name,
    maker_name: item.maker_name,
    maker_country_name: item.maker_country_name,
  }));

export const useUnboundDrugs = () => {
  const orderGuid = useReconciliationOrderGuid();

  return useQuery({
    queryKey: ReconciliationQueryKeys.unboundBindings(orderGuid),
    queryFn: () => BindingsApi.fetchBindings({ order_guids: orderGuid, unbond: true }),
    enabled: Boolean(orderGuid),
    select: selectUnboundBindings,
  });
};
